<template>
  <div
    :class="[
      $style['color'],
      { [$style['color--small']]: small },
      { [$style['color--selected']]: selected },
      { [$style['color--disabled']]: disabled },
    ]"
    :tabIndex="tabIndex">
    <div
      :class="$style['color__preview']"
      :style="arrayToGradient(color, false)">
      <SvgIcon
        v-if="showIcon"
        name="System/check-line"
        :class="[
          $style['color__icon'],
          { [$style['color__icon--visible']]: selected }
        ]"
        :style="{ color: contrastColor(color) }" />
    </div>
    <div
      v-if="name"
      :class="$style['color__name']">
      {{ name }}
    </div>
  </div>
</template>
<script setup>
import { contrastColor, arrayToGradient } from '~/helpers/colors'

defineProps({
  disabled: {
    type: Boolean,
    default: false
  },
  selected: {
    type: Boolean,
    default: false
  },
  name: {
    type: String,
    default: ''
  },
  color: [String, Object, Array],
  showIcon: {
    type: Boolean,
    default: false
  },
  small: {
    type: Boolean,
    default: false
  },
  tabIndex: {
    type: [String, Number],
    default: 0
  }
})

</script>
<style lang="scss" module>
.color {
  cursor: pointer;
  align-items: center;
  display: inline-flex;
  flex-direction: column;
  font-size: var(--font-size-s);

  &:focus-visible .color__preview {
    box-shadow: var(--focus-visible);
  }

  &:hover {
    .color__icon:not(.color__icon--visible) {
      opacity: 0.25;
      transform: scale(1);
    }
  }

  &__name {
    line-height: 1;
    margin-top: var(--spacing);
    font-size: var(--font-size-xs);
    word-break: break-all;
    text-align: center;
  }

  &__preview {
    background-size: cover;
    border-radius: 100%;
    box-shadow: inset 0 0 4px var(--black-20-opacity);
    display: flex;
    align-items: center;
    justify-content: center;
    width: calc(var(--spacing ) * 4);
    height: calc(var(--spacing ) * 4);
    position: relative;
  }

  &__icon {
    position: absolute;
    opacity: 0;
    height: calc(var(--spacing ) * 2);
    width: calc(var(--spacing ) * 2);

    &--visible {
      opacity: 1;
    }
  }

  &--small {
    .color__preview {
      box-shadow: inset 0 0 2px 1px var(--black-10-opacity), 0 0 0 2px var(--white);
      width: calc(var(--spacing) * 1.5);
      height: calc(var(--spacing) * 1.5);
      transform: translate3d(0, 0, 0);
    }
  }

  &--disabled {
    pointer-events: none;
    opacity: 0.25;
  }

  &--selected {
    box-shadow: none;

    .color__preview {
      border: 2px solid var(--black);
      box-shadow: inset 0 0 0 2px var(--white);
    }
  }
}
</style>
